import React, { type ReactNode } from 'react';

import { Columns, Divider, Footer, Header, Results, Section } from './components';

import { LayoutWrapper } from './styles';

export interface LayoutProps {
    children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
    return <LayoutWrapper>{children}</LayoutWrapper>;
}

Layout.Columns = Columns;
Layout.Divider = Divider;
Layout.Footer = Footer;
Layout.Header = Header;
Layout.Results = Results;
Layout.Section = Section;
